import { DeleteButton, Edit, SaveButton, SimpleForm, Toolbar } from "react-admin";

import RelayAccessRequestFormFields, {
  transformRelayAccessRequestUpdate,
} from "./RelayAccessRequestFormFields";

const EditToolbar = () => (
  <Toolbar sx={{ flexWrap: "wrap", gap: 1 }}>
    <SaveButton />
    <DeleteButton
      mutationMode="pessimistic"
      redirect="list"
      confirmTitle="Revoke relay access and delete this request?"
    />
  </Toolbar>
);

const RelayAccessRequestEdit = () => (
  <Edit mutationMode="pessimistic" transform={transformRelayAccessRequestUpdate} redirect="show">
    <SimpleForm
      warnWhenUnsavedChanges
      sx={{ maxWidth: 640, width: "100%" }}
      toolbar={<EditToolbar />}
    >
      <RelayAccessRequestFormFields mode="edit" />
    </SimpleForm>
  </Edit>
);

export default RelayAccessRequestEdit;
